import styled from "styled-components";

// Material
import _Container from "@material-ui/core/Container";
import _Box from "@material-ui/core/Box";
import _Paper from "@material-ui/core/Paper";
import _Grid from "@material-ui/core/Grid";
import _DialogActions from "@material-ui/core/DialogActions";
import _Button from "@material-ui/core/Button";
import _FormControlLabel from "@material-ui/core/FormControlLabel";

/* -------- Estilização ---------- */

export const PainelContainer = styled(_Container)`
  margin-top: 15vh;
`;

export const Grid = styled(_Grid)``;

export const BodyPainel = styled(_Paper)`
  min-height: 70vh;
  padding: 15px;
  ${Grid} {
    margin-top: 10px;
  }
`;

export const BallContainer = styled.div`
  img {
    width: 20px;
    transform: translateX(-50%);
  }
`;

export const FormControlLabel = styled(_FormControlLabel)``;

export const SwitchBox = styled(_Box)`
  width: 100%;
  text-align: center;

  ${FormControlLabel} {
    margin: 0;
    margin-top: ${(props) => props.theme.spacing(1.8)} !important;
    height: calc(100% - ${(props) => props.theme.spacing(1.8)}) !important;
  }
`;

export const StyledButton = styled(_Button)`
  width: 100%;
  height: calc(100% - ${(props) => props.theme.spacing(1.8)});
  margin-top: ${(props) => props.theme.spacing(1.8)} !important;
  background-color: ${(props) =>
    props.theme.palette[props.themecolor]} !important;
  color: #fff !important;
  &:hover {
    color: ${(props) =>
      props.hovercolor
        ? props.hovercolor[0] === "light"
          ? "rgba(0, 0, 0, 0.87)"
          : "#FFF "
        : "#FFF"} !important;
    background-color: ${(props) =>
      props.hovercolor
        ? props.theme.palette[props.hovercolor[1]]
        : props.theme.palette.orange} !important;
  }
`;

export const DialogActions = styled(_DialogActions)`
  padding: ${(props) => props.theme.spacing(1)}
    ${(props) => props.theme.spacing(3)} !important;
  justify-content: space-between !important;
  ${StyledButton} {
    margin-top: 0 !important;
  }
`;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-size: 1.2rem;
    }
  }
`;
